module.exports = __webpack_public_path__ + "img/omzet.fe7812b8.svg";